export default "__VITE_ASSET__DyZzvkh4__"